import { useState } from "react";
import "./index.scss";
import { FaCrown } from '@react-icons/all-files/fa/FaCrown';
import { COLOR_OPTIONS, FONT_OPTIONS, LAYOUTS, SPACING_OPTIONS, TEMPLATES } from "./constants";
import ResumeCanvasPreview from "../../../../components/pdf/ResumeCanvasPreview";



const ATSBadge = () => (
  <div className="ats-badge">
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="9" cy="9" r="9" fill="#059669" />
      <path d="M5 9.5L8 12.5L13 7.5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
    <span>ATS</span>
  </div>
);

const BlueCheck = () => (
  <div className="blue-check">
    <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="11" cy="11" r="11" fill="#2563eb" />
      <path d="M6 12L10 16L16 8" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  </div>
);


const DesignStep = (props) => {
  const [selectedTab, setSelectedTab] = useState("styles");
  const { design } = props.params;
  const { style, layout, font = 'verdana', spacing = 'normal', color = 'black' } = design || { style: 'bentz', layout: 'centered', font: 'verdana', spacing: 'normal', color: 'black' };

  // Helper to check if a template is locked (all except the first)

  const handleTemplateClick = (tpl, idx) => {

    props.onChange('style', tpl.key);
  };

  return (
    <div className="design-step">
      {/* Canvas PDF Preview */}
      <div className="pdf-preview-container">
        <ResumeCanvasPreview resume={props.resume} />
      </div>
      <div className="floating-menu">
        <div className="tab-content">
          {selectedTab === "styles" && (
            <div className="styles-tab">
              <div className="template-list">
                {TEMPLATES.map((tpl, idx) => {
                  const locked = false // isLocked(idx);
                  return (
                    <div
                      key={tpl.key}
                      className={`template-card${style === tpl.key ? " selected" : ""}${locked ? " locked" : ""}`}
                      onClick={() => handleTemplateClick(tpl, idx)}
                    >
                      <img src={tpl.img} alt={tpl.label} />
                      <ATSBadge />
                      {style === tpl.key && !locked && <BlueCheck />}
                      {locked && (
                        <div className="lock-overlay">
                          <FaCrown color="#FFA940" size={38} />
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          )}
          {selectedTab === "layout" && (
            <div className="layout-tab">
              <div className="layout-options">
                {LAYOUTS.map((currentLayout) => (
                  <button
                    key={currentLayout.key}
                    className={`layout-button${layout === currentLayout.key ? " selected" : ""}`}
                    onClick={() => props.onChange('layout', currentLayout.key)}
                  >
                    {currentLayout.icon}
                    <span>{currentLayout.label}</span>
                  </button>
                ))}
              </div>
            </div>
          )}
          {selectedTab === "fonts" && (
            <div className="fonts-tab">
              {false && <div className="spacing-options">
                {SPACING_OPTIONS.map((option) => (
                  <button
                    key={option.key}
                    className={`spacing-button${spacing === option.key ? " selected" : ""}`}
                    onClick={() => props.onChange('spacing', option.key)}
                  >
                    {`${option.icon} ${option.label}`}
                  </button>
                ))}
              </div>}
              <div className="font-options">
                {FONT_OPTIONS.map((option) => (
                  <button
                    key={option.key}
                    className={`font-button${font === option.key ? " selected" : ""}`}
                    onClick={() => props.onChange('font', option.key)}
                  >
                    <div className="font-name" style={{ fontFamily: option.fallback }}>{option.label}</div>
                    <div className="font-preview" style={{ fontFamily: option.fallback }}>{option.preview}</div>
                  </button>
                ))}
              </div>
            </div>
          )}
          {selectedTab === "colors" && (
            <div className="colors-tab">
                {COLOR_OPTIONS.map((option) => (
                  <div className={`color-option ${color === option.key ? "selected" : ""}`} 
                  onClick={() => props.onChange('color', option.key)}
                  style={{ background: option.viewBackgroundColor,  }}>
                    <div className="inner-option" style={{background: option.viewInnerColor}}>
                      </div>
                  </div>
                ))}
            </div>
          )}          
        </div>
        <div className="tabs">
          <div
            className={`tab${selectedTab === "styles" ? " active" : ""}`}
            onClick={() => setSelectedTab("styles")}
          >
            Styles
          </div>
          <div
            className={`tab${selectedTab === "layout" ? " active" : ""}`}
            onClick={() => setSelectedTab("layout")}
          >
            Layout
          </div>
          <div
            className={`tab${selectedTab === "colors" ? " active" : ""}`}
            onClick={() => setSelectedTab("colors")}
          >
            Colors
          </div>
          <div
            className={`tab${selectedTab === "fonts" ? " active" : ""}`}
            onClick={() => setSelectedTab("fonts")}
          >
            Fonts
          </div>
        </div>
      </div>
    </div>
  );
};

export default DesignStep;